export default "__VITE_ASSET__647b9725__"